import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService, NotifyService } from '@app/services';
import { UpdateView } from '@common/views';
import { TimeOffRequest } from '@models/time-off-v3/time-off-request.model';
import { ActionType } from '@time-off-v3/components/time-off-request/time-off-request.component';

@Component({
    templateUrl: './request-update.template.html',
})
export class RequestUpdateView extends UpdateView {
    timeOffRequest: TimeOffRequest;
    actionType: ActionType = 'update';
    isLoading: boolean;

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private router: Router,
        private analyticService: AnalyticService
    ) {
        super();
        this.timeOffRequest = this.route.snapshot.data.models.get('request');
    }

    async onSave(timeOffRequest: TimeOffRequest): Promise<void> {
        this.isLoading = true;

        try {
            await timeOffRequest.save();
            this.notify.success('time-off-v3.requestHasBeenUpdatedSuccessfully');
            this.analyticService.trackEvent(AnalyticEvents.TimeOffManageRequestMeatBallEdit);
            this.router.navigate(['/', 'time-off', 'v3', 'requests', timeOffRequest.id]);
        } catch (e) {
            this.notify.error(e);
        } finally {
            this.isLoading = false;
        }
    }
}
